/**
 * Entry-mode signalling for the consent-banners portal (AB#25457).
 *
 * The consent-banners app shows its own native navbar by default ("standalone").
 * Entries made from *inside* the admin portal pass 'embedded' so the app keeps
 * the admin-portal navbar instead. Only embedded is signalled — standalone is
 * the app's default when the param is absent, so we never append it.
 *
 * Kept dependency-free so it can be unit-tested with the Node built-in test
 * runner (the admin portal has no wired-up Jest), mirroring the existing
 * `behavior-options` util/spec pattern.
 */

export const NAV_MODE_QUERY_PARAM = 'nav'
export const NAV_MODE_EMBEDDED = 'embedded'

/**
 * Append the entry-mode signal to an exchange redirect URL.
 * @param {string} redirectUrl absolute exchange redirect URL (…/auth?drkpnk=…)
 * @param {string} [navMode] the entry mode; only 'embedded' is appended
 * @returns {string} the URL, with `nav=embedded` added when embedded
 */
export function withNavMode (redirectUrl, navMode) {
	if (navMode !== NAV_MODE_EMBEDDED) return redirectUrl
	try {
		const url = new URL(redirectUrl)
		url.searchParams.set(NAV_MODE_QUERY_PARAM, NAV_MODE_EMBEDDED)
		return url.toString()
	} catch (e) {
		// Defensive: if the URL can't be parsed, append manually.
		const separator = redirectUrl.includes('?') ? '&' : '?'
		return `${redirectUrl}${separator}${NAV_MODE_QUERY_PARAM}=${NAV_MODE_EMBEDDED}`
	}
}
